import React from 'react'
import '../assets/css/Footer.css'
import { Link } from 'react-router-dom'
const Footer = () => {
  
  return (
    <>
    <div className="ftr-stared">
    <div className=" footer-div">
    <footer className="footer container">
          <div className="col first-clomn">
            <div className='footer-svg'>
              <svg
                preserveAspectRatio="xMidYMid meet"
                data-bbox="0 0 260 37"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 260 37"
                height="37"
                width="260"
                data-type="color"
                role="presentation"
                aria-hidden="true"
                aria-label=""
              >
                <g>
                  <path
                    fill="#ffffff"
                    d="M3.906 5.224q0-2.22-.608-3.265Q2.691.87.868.87H0V0h11.283q4.73 0 8.203 1.567Q23 3.135 23 7.617q0 2.047-1.389 3.7-1.389 1.655-4.253 2.612 3.992.654 5.555 2.394 1.606 1.698 1.606 4.571 0 4.397-3.472 6.138-3.428 1.697-8.463 1.697h-8.68zm8.028 8.053q1.78 0 3.342-.653 1.606-.697 2.604-2.003.998-1.35.998-3.221 0-1.959-1.172-3.265-1.17-1.35-2.994-1.959a10.5 10.5 0 0 0-3.645-.652q-1.52 0-3.255.435v11.318zm0 13.929q3.95 0 6.076-1.567 2.17-1.567 2.17-4.527t-2.126-4.527q-2.084-1.567-6.12-1.567H7.812v11.578q2.083.61 4.122.61"
                    data-color="1"
                  ></path>
                  <path
                    fill="#ffffff"
                    d="M34.287 29.165q-1.388 0-2.82-.566-1.433-.61-2.474-1.959-.998-1.35-.998-3.57 0-3.308 3.037-4.7 3.081-1.394 8.03-1.393h1.301q0-4.266-1.172-5.834t-3.385-1.567q-1.953 0-3.124.827-1.172.828-1.65 2.874H29.08q0-1.48.173-2.308.174-.87.912-1.61.78-.784 2.56-1.132 1.823-.392 3.95-.392 3.514 0 5.554 1.916 2.04 1.87 2.04 7.226v11.752h-2.17l-1.519-1.958h-.217q-.78 1-2.3 1.697t-3.776.697m1.953-1.96q1.432 0 2.387-.696t1.736-1.915v-5.876h-1.302q-3.21 0-5.077 1.218-1.867 1.176-1.867 3.135 0 2.002 1.172 3.09 1.215 1.045 2.951 1.045"
                    data-color="1"
                  ></path>
                  <path
                    fill="#ffffff"
                    d="M58.696 29.165q-3.125 0-5.294-1.393-2.126-1.437-3.212-3.83-1.041-2.439-1.041-5.442t1.041-5.398q1.085-2.438 3.212-3.83 2.17-1.437 5.294-1.437 4.774 0 6.293 1.524.738.74.911 1.828.174 1.045.174 3.83h-.868q-.174-2.698-1.693-4.048-1.519-1.393-3.949-1.393-3.125 0-4.73 2.482-1.562 2.48-1.562 6.442 0 3.96 1.562 6.442 1.605 2.482 4.73 2.482 2.213 0 3.646-.828 1.431-.87 2.647-2.655l.868.653q-1.432 2.437-3.385 3.526-1.953 1.045-4.644 1.045"
                    data-color="1"
                  ></path>
                  <path
                    fill="#ffffff"
                    d="M86.705 29.165q-3.689 0-6.293-3.483l-5.207-6.964v10.011h-3.906V5.224q0-2.22-.608-3.265Q70.083.87 68.261.87h-.868V0H71.3q1.605 0 2.387.435.825.392 1.172 1.48t.347 3.309v12.84L80.63 11.1q1.129-1.393 2.387-2.09 1.26-.74 3.255-.74h1.302v1.09q-1.172 0-2.256.479a4.8 4.8 0 0 0-1.867 1.48l-4.773 6.094 5.424 6.965q1.259 1.654 2.344 2.48 1.128.828 2.43 1.045v.827q-.954.435-2.17.436"
                    data-color="1"
                  ></path>
                  <path
                    fill="#ffffff"
                    d="M99.783 29.165q-3.255 0-5.338-1.741-2.04-1.742-2.04-6.095v-7.835q0-2.22-.607-3.265-.608-1.088-2.43-1.088h-.434v-.87h3.472q1.605 0 2.386.435.825.391 1.172 1.48.348 1.088.347 3.308v7.835q0 3.047 1.346 4.484 1.388 1.393 3.428 1.393 2.3 0 4.34-2.307V8.27h3.906v20.458h-2.17l-1.519-1.74h-.217q-.912.913-2.387 1.566-1.433.61-3.255.61"
                    data-color="1"
                  ></path>
                  <path
                    fill="#ffffff"
                    d="M116.238 13.494q0-2.22-.608-3.265-.608-1.088-2.43-1.088h-.868v-.87h3.906q1.649 0 2.473.478.868.436 1.216 1.48h.217q.78-1 2.213-1.697t3.645-.697q3.732 0 5.772 3.047 2.04 3.004 2.04 7.618 0 4.658-2.127 7.661-2.082 3.004-6.119 3.004-1.648 0-2.907-.348a15 15 0 0 1-2.517-.958V37h-3.906zm8.028 13.93q2.778 0 4.08-2.438 1.345-2.437 1.345-6.486 0-4.005-1.258-6.442-1.259-2.482-3.733-2.482-2.907 0-4.556 2.612v13.93q1.302.609 2.256.957a5.4 5.4 0 0 0 1.866.349"
                    data-color="1"
                  ></path>
                  <path
                    fill="#71C55D"
                    d="M172.015 30.688q-3.124 0-4.861-.957-1.735-.959-2.473-2.96-.695-2.046-.695-5.442V4.571l-10.849 24.158h-.868L140.985 4.135V28.73h-1.735V0h4.122l10.416 22.635L163.986 0h3.906v21.33q0 4.047.998 6.268 1.042 2.22 3.125 2.22z"
                    data-color="2"
                  ></path>
                  <path
                    fill="#71C55D"
                    d="M182.989 29.165q-2.951 0-4.991-1.393-2.04-1.437-3.081-3.83-1.042-2.439-1.042-5.442 0-2.96 1.042-5.398 1.041-2.438 2.994-3.83 1.996-1.437 4.644-1.437 4.383 0 6.51 2.481 2.169 2.438 2.169 7.096l-.086 1.74h-13.15q0 3.658 1.562 5.964 1.563 2.308 4.297 2.308 2.04 0 3.428-.871 1.432-.87 2.647-2.612l.868.653q-1.431 2.394-3.341 3.482t-4.47 1.089m4.123-11.753q0-3.83-1.129-5.833-1.128-2.003-3.428-2.003-1.302 0-2.344 1.045-1.041 1.001-1.649 2.786-.564 1.785-.564 4.005z"
                    data-color="2"
                  ></path>
                  <path
                    fill="#71C55D"
                    d="M196.585 13.494q0-2.22-.608-3.265-.607-1.088-2.43-1.088h-.434v-.87h3.472q1.648 0 2.473.478.869.436 1.215 1.48h.217q.781-1 2.083-1.697 1.346-.697 3.125-.697 1.736 0 2.604.653.738.565 1.519 1.96l-1.736 1.305q-.477-.653-1.389-.958-.911-.348-2.083-.348-1.302 0-2.387.61-1.085.566-1.736 1.566V28.73h-3.905z"
                    data-color="2"
                  ></path>
                  <path
                    fill="#71C55D"
                    d="M218.347 29.165q-1.389 0-2.821-.566-1.432-.61-2.474-1.959-.998-1.35-.998-3.57 0-3.308 3.038-4.7 3.08-1.394 8.029-1.393h1.302q0-4.266-1.172-5.834t-3.385-1.567q-1.953 0-3.125.827-1.172.828-1.649 2.874h-1.953q0-1.48.174-2.308.173-.87.911-1.61.781-.784 2.561-1.132 1.822-.392 3.949-.392 3.515 0 5.555 1.916 2.039 1.87 2.039 7.226v11.752h-2.17l-1.518-1.958h-.217q-.781 1-2.301 1.697-1.518.697-3.775.697m1.953-1.96q1.432 0 2.387-.696.954-.696 1.736-1.915v-5.876h-1.302q-3.212 0-5.078 1.218-1.866 1.176-1.866 3.135 0 2.002 1.172 3.09 1.214 1.045 2.951 1.045"
                    data-color="2"
                  ></path>
                  <path
                    fill="#71C55D"
                    d="M249.786 29.165q-3.689 0-6.292-3.483l-5.208-6.964v10.011h-3.906V5.224q0-2.22-.608-3.265-.608-1.088-2.43-1.088h-.868V0h3.906q1.605 0 2.387.435.825.392 1.172 1.48t.347 3.309v12.84l5.425-6.964q1.128-1.393 2.386-2.09 1.259-.74 3.255-.74h1.302v1.09q-1.172 0-2.256.479a4.8 4.8 0 0 0-1.867 1.48l-4.773 6.094 5.424 6.965q1.259 1.654 2.344 2.48 1.128.828 2.43 1.045v.827q-.955.435-2.17.436"
                    data-color="2"
                  ></path>
                  <path
                    fill="#71C55D"
                    d="M257.743 5.659q-.998 0-1.736-.827-.694-.828-.694-1.96 0-.912.521-1.436.564-.522 1.475-.522.999 0 1.693.827.738.827.738 1.959 0 .915-.565 1.436-.52.523-1.432.523m-1.649 7.835q0-2.22-.607-3.265-.608-1.088-2.431-1.088h-.868v-.87h3.906q1.606 0 2.387.435.825.391 1.172 1.48t.347 3.308V28.73h-3.906z"
                    data-color="2"
                  ></path>
                </g>
              </svg>
            </div>
            <p>
              This online tool allows you to back up and restore your Cisco
              Meraki Dashboard configuration.
            </p>
          </div>
          <div className="col second-clomn  sec-class">
            <h2 className='ftr-content'>Quick Links</h2>
            <ul className="list-unstyled ftr-ultr">
            <Link to='/security'><li>Security</li></Link>
            <Link to='/pricing'><li>Pricing</li></Link>
            <Link to='/about-us'><li>About Us</li></Link> 
            </ul>
          </div>
          <div className="col second-clomn third-clomn">
            <h2 className='ftr-content'>Product</h2>
            <ul className="list-unstyled ftr-ultr">
            <Link to='/how-it-works'><li>How it works</li></Link>
            <Link to='/faq'>  <li>FAQ</li></Link>
            <Link to='/release-notes'>  <li>Release Notes</li></Link>
            </ul>
          </div>
          <div className="col second-clomn forth-clomn">
            <h2 className='ftr-content'>Terms of Use</h2>
            <ul className="list-unstyled ftr-ultr">
            <Link to='/privacy-policy' > <li>Privacy Policy</li></Link>
            <Link to='/terms-of-service'> <li>Terms of Service</li></Link> 
            </ul>
          </div>
          <div className="col second-clomn fifth-clomn">
            <h2 className='ftr-content'>Contact Us</h2>
            <ul className='list-unstyled ftr-ultr'>
            <li className="mb-1 ftr-para">Nexivity Pty Ltd <br/>Cisco Meraki Ecosystem Partner</li>
            <li className="mb-1 ftr-para">E-mail: contact@backupmeraki.com</li>
            <li>Address: Level 12, 64 York St, Sydney, NSW 2000, Australia</li>
            </ul>
            
          </div>
          
          
          
    </footer>
    <div className='text-center copy-right'>
        <hr style={{color:"white",opacity:'1'}}/>
        <p className='copy-ryt-para' style={{color:"white"}}>© Copyrights Backup Meraki 2021-2026. All rights reserved. Powered by <Link to='https://www.nexivity.net' target="_blank">Nexivity</Link>.</p>
    </div>
    </div>
    </div>
    </>
  )
}

export default Footer